import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class TranslationModel extends Model
{
	@attr chip;
	@attr bib;
	@attr lot;
	@attr name;
	@attr startTime;
	@attr endTime;
	@attr('boolean', { defaultValue: false }) isBackup;
}